<template>
    <div class="h-100">
        <!-- <nav v-if="selectedComponent == 'facedtection-profiles'" class="navbar navbar-expand-lg p-0">
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav w-100 top-nav-bar">
                    <a class="nav-item nav-link w-50" :class='(activeIndex == "faceDetection")?"active":"inactive"' style="width:20% !important">Face Detection</a>
                    <a class="nav-item nav-link w-50" :class='(activeIndex == "ObjectDetection")?"active":"inactive"' style="width:20% !important">Obejct Detection</a>
                </div>
            </div>
        </nav> -->
        <div class="col-md-12 p-0" style="height:calc(100vh - 65px)"> <!-- height:calc(100vh - 110px)-->
            <!-- <facedtection-profiles 
                v-if="activeIndex == 'faceDetection'"
                @openPersonality="openPersonality">
                
            </facedtection-profiles>  
            <personality
                v-if="showIndPersonality"
                :personalityData="indPersonalityData"
                >
            </personality>   -->

            <component
            :is="selectedComponent"
            @changeSelectedComponent="changeSelectedComponent"
            :personalityId="selectedPersonalityId"
            ></component>
        </div>
    </div> 
</template>

<script>
    import {mapActions} from "vuex"
    import faceDetectionProfilesMain from "../AIDataSetTraining/faceDetectionPersonalitiesMain.vue"
    import individualPersonality from "./individualPersonality.vue"
    
    export default {
        data(){
            return{
                activeIndex:"faceDetection",
                showIndPersonality:false,
                selectedComponent:"facedtection-profiles",
                selectedPersonalityId:null,
            }
        },
        components:{
            "facedtection-profiles":faceDetectionProfilesMain,
            "individual-personality":individualPersonality
        },
        methods:{
            changeSelectedComponent(comp, info = {}){
                this.selectedComponent = comp;
                if(comp == "individual-personality" && info){
                    this.selectedPersonalityId = info;
                }
            },
            ...mapActions("AIDataSet", ["getIndividualPersoanlityDataFromServer"])
        },
        created(){
        }
    }    
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

    .nav-item{
        color: $dull-text-color !important;
    }
    .inactive:hover{
    color:$text-color !important;
    }
    .active{
        background: $primary-background !important;
        color:$active-blue  !important;
        border-bottom: 2px solid $active-blue ;
        font-weight: 500;
        font-size:15px;
    }
    .top-nav-bar{
        background: $primary-background;
    }
</style>
